import React from "react";
import TeamOverview from "./components/TeamOverview";
import PageHeader from "./components/common/PageHeader";
import LeadStatus from "./components/LeadStatus";
import MaoStatus from "./components/MaoStatus";
import LeadAge from "./components/LeadAge";
// import MerchantHealth from "./components/MerchantHealth";
import useFetch from "./hooks/useFetch";

export default function OnlineDashboard() {
  const url = `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/mdo-list?page_index=0&page_size=1000&show=all`;
  const dataStateMdo = useFetch(url, null);

  return (
    <div>
      <div>
        <div>
          {/* <PageHeader text={"Dashboard"} /> */}
          {/* <CalendarDatePicker page={"new_dashboard"} date={date} /> */}
        </div>
      </div>

      <TeamOverview />
      <LeadStatus dataStateMdo={dataStateMdo} />
      <MaoStatus dataStateMdo={dataStateMdo} />
      {/* <MerchantHealth /> */}
      <LeadAge />
    </div>
  );
}
